import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

export const HeroAnimation = () => {
    // Generate sparks
    const sparks = useMemo(() => {
        return Array.from({ length: 30 }).map((_, i) => ({
            id: i,
            left: `${5 + Math.random() * 90}%`, // Rozproszenie od 5% do 95% szerokości
            width: Math.random() * 2 + 1,       // 1px do 3px szerokości
            height: Math.random() * 8 + 4,      // 4px do 12px wysokości (smugi)
            duration: Math.random() * 3 + 4,    // 4s do 7s na dotarcie na szczyt
            delay: Math.random() * 5,           // Start w różnych momentach
            xOffset: Math.random() > 0.5 ? 30 : -30, // Dryfowanie lewo/prawo
        }));
    }, []);

    return (
        <div className="absolute inset-0 overflow-hidden bg-[#152440] dark:bg-[#060f1e] pointer-events-none -z-10">
            {/* Background Texture (Noise) */}
            <div className="absolute inset-0 opacity-[0.04] bg-[url('/noise.png')]" />

            {/* Animated Blueprint / Scanning Grid */}
            <motion.div
                animate={{ y: [0, 64] }} // 64px = 4rem (wysokość jednej kratki) -> płynna pętla bez końca
                transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
                className="absolute -top-16 -left-16 -right-16 bottom-0 opacity-[0.15]"
                style={{
                    backgroundImage: `
            linear-gradient(rgba(37, 99, 180, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(37, 99, 180, 0.3) 1px, transparent 1px)
          `,
                    backgroundSize: '4rem 4rem',
                }}
                aria-hidden
            />

            {/* Atmospheric Glowing Orbs - Hardware-accelerated translation for zero lag */}
            <motion.div
                animate={{
                    x: ['0%', '15%', '0%'],
                    y: ['0%', '10%', '0%']
                }}
                transition={{ duration: 20, repeat: Infinity, ease: 'easeInOut' }}
                className="absolute -top-[20%] -left-[10%] w-[60vw] h-[60vw] max-w-[800px] max-h-[800px] rounded-full bg-blue-400/30 dark:bg-blue-500/20 blur-[100px]"
            />
            <motion.div
                animate={{
                    x: ['0%', '-15%', '0%'],
                    y: ['0%', '-10%', '0%']
                }}
                transition={{ duration: 25, repeat: Infinity, ease: 'easeInOut' }}
                className="absolute top-[40%] -right-[10%] w-[50vw] h-[50vw] max-w-[600px] max-h-[600px] rounded-full bg-cyan-400/20 dark:bg-cyan-500/20 blur-[100px]"
            />

            {/* Welding / Industrial Sparks travelling upwards */}
            {sparks.map((spark) => (
                <motion.div
                    key={spark.id}
                    className="absolute bottom-[-10%] bg-blue-300 rounded-full shadow-[0_0_12px_rgba(147,197,253,0.8)]"
                    style={{
                        left: spark.left,
                        width: spark.width,
                        height: spark.height,
                    }}
                    initial={{ y: 0, opacity: 0 }}
                    animate={{
                        y: '-110vh', // Lecą wyżej niż sam ekran
                        opacity: [0, 1, 1, 0],
                        x: [0, spark.xOffset, 0] // Zigg-zaggowanie jak iskry w powietrzu
                    }}
                    transition={{
                        duration: spark.duration,
                        repeat: Infinity,
                        delay: spark.delay,
                        ease: "easeOut"
                    }}
                />
            ))}

            {/* Light Shadow Overlays just for text readability, mostly transparent */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#152440] dark:from-[#060f1e] via-[#152440]/30 dark:via-[#060f1e]/30 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#152440]/50 dark:from-[#060f1e]/50 via-transparent to-transparent" />
        </div>
    );
};
